import { render } from "./two-column-video-block.vue?vue&type=template&id=77a9ae7b"
import script from "./two-column-video-block.vue?vue&type=script&lang=js"
export * from "./two-column-video-block.vue?vue&type=script&lang=js"

import "./two-column-video-block.vue?vue&type=style&index=0&id=77a9ae7b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__